import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./DonationsYearlyChart.module.scss";
import { thousandize } from "../../../../util/formatting";
export const DonationsYearlyGraph: React.FC<{
  data: {
    year: string;
    sum: number;
  }[];
}> = t0 => {
  const $ = _c(16);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    t1 = Math.max(...data.map(_temp));
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const max = t1;
  let t2;
  if ($[2] !== data || $[3] !== max) {
    let t3;
    if ($[5] !== max) {
      t3 = el_0 => <div key={el_0.year} className={style.bar} style={{
        height: `${el_0.sum / max * 100}%`
      }} />;
      $[5] = max;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = data.map(t3);
    $[2] = data;
    $[3] = max;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className={style.bars}>{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== data) {
    t4 = data.map(_temp2);
    $[9] = data;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className={style.labels}>{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className={style.wrapper}>{t3}{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(el) {
  return el.sum;
}
function _temp2(el_1) {
  return <div key={el_1.year} className={style.label}><span>{el_1.year}</span><span>{thousandize(Math.round(el_1.sum))} kr</span></div>;
}